export const stripScheme = (url?: string) => {
  return url?.replace(/www\.|https:\/\/|http:\/\//g, '');
};
